import type { FC } from "react";
import styled from "styled-components";
import { MenuContainer } from "./MenuContainer";
import { SidebarContainer } from "./SidebarContainer";
import "@nectary/components/skeleton";
import "@nectary/components/skeleton-item";

const ProfileItemContainer = styled.div`
  display: inline-flex;
  flex: 1;
  position: absolute;
  background: white;
  overflow: hidden;
  bottom: 0;
  right: 0;
  left: 0;
`;

export const SidebarScaffold: FC<{ skeleton?: boolean }> = ({ skeleton }) => (
  <SidebarContainer show={false}>
    <MenuContainer>
      {skeleton && (
        <div style={{ width: "100%", padding: "16px 16px 0px" }}>
          <sinch-skeleton>
            <sinch-skeleton-item />
            <sinch-skeleton-item />
            <sinch-skeleton-item />
            <sinch-skeleton-item />
            <sinch-skeleton-item />
          </sinch-skeleton>
        </div>
      )}
      <ProfileItemContainer style={{ padding: 16 }}>
        {skeleton && (
          <sinch-skeleton style={{ width: "100%" }}>
            <sinch-skeleton-item />
          </sinch-skeleton>
        )}
      </ProfileItemContainer>
    </MenuContainer>
  </SidebarContainer>
);
